import FavouriteItem from './components/FavouriteItem/FavouriteItem'
import '../FavouritePage/FavouritePage.scss'



const FavouritePage = ({cart,cartItem,addToCart,removeFromCart,favourite,addToFavourite,removeFromFavourite}) =>{

const itemInFavourite = favourite.map(inFavourite =>{
    
   return <FavouriteItem title={inFavourite.title} url={inFavourite.url} color={inFavourite.color} addToCart={addToCart}
                            id={inFavourite.id} removeFromFavourite={removeFromFavourite} inFavourite={inFavourite} price={inFavourite.price} />
})
 const noItem = <p className='favourite-page__no-item'>You have no favorite products...</p>
    return(
        <>
        
        <div className='favourite-page'>
                {itemInFavourite.length <= 0 && noItem}
            <div className='favourite-page__container'>
                <div className='favourite-page__wrap'>
                    {itemInFavourite}
                </div>
            </div>
                
        </div>
        
        </>
    )
}

export default FavouritePage;